export default {
  path: '/change-password',
  name: 'changePassword',
  component: () => import(/* webpackChunkName: "changePassword" */ './_views/ChangePassword.vue'),
  meta: {
    title: 'Change Password',
  },
};
